// El valor viaja al backend como `campo|direccion`; solo se permite la fecha de publicacion
const sortOptions = [
  {
    value: 'publishedDate|desc',
    label: 'Más nuevos',
  },
  {
    value: 'publishedDate|asc',
    label: 'Más antiguos',
  },
];

export const DEFAULT_SORT = sortOptions[0].value;

export default sortOptions;
